// THE account check (docs/SHARED.md "Accounts"; docs/SPEC.md "Two stages, two modes"; nowish.json accountFeatures):
// every personal control runs its action through this. In personal mode it runs. In public mode (nowish.fyi, logged
// out) it shows the "Coming soon: sign-in" note instead (account.comingSoon); when sign-in arrives, that note becomes
// the sign-in prompt and nothing else changes.
import { MODE } from "../app/mode";
import { SHARED, T } from "../shared/config";
import { showNote } from "../state/note";

/** Whether personal features work here (personal mode; later: signed in). */
export const accountOpen = () => MODE === "personal";

export function requireAccount<R>(feature: string, action: () => R): R | undefined {
  if (!SHARED.accountFeatures.includes(feature)) throw new Error(`requireAccount: ${feature} isn't in nowish.json accountFeatures`);
  if (!accountOpen()) { showNote(T("account.comingSoon")); return undefined; }
  return action();
}

/** The same gate as a hook, for components: when sign-in arrives it can read the account from React context here, and no caller changes. */
export const useRequireAccount = () => requireAccount;
